<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      @reset="reset"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import {
  // getEnumList,
  selectSysStaticDataByCodeType,
  getDepartmentAllList,
} from 'api';
import TableBox from './tableBox';
import {
  getAddressOptions,
} from '@qx/utils';
export default {
  name: 'manageArchivesCustomerLine',
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        stateOptions: [],
        vehicleStatusOptions: [],
        // 归属部门
        orgIdOptions: [],
        form: [
          {
            label: '',
            value: 'vehicleStatus',
            type: 'radio',
            default: '-1',
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          { // 线路编码
            label: '线路编码',
            value: 'lineCodeRule',
            type: 'input',
            placeholder: '请输入线路编码',
          },
          { // 线路关键字
            label: '线路关键字',
            value: 'lineKeyWord',
            type: 'input',
            placeholder: '请输入线路关键字',
          },
          { // 客户全称
            label: '客户全称',
            value: 'companyName',
            type: 'input',
            default: this.$route.query.companyName,
            placeholder: '请输入客户全称',
          },
          { // 线路名称
            label: '线路名称',
            value: 'lineCodeName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请输入归属部门',
          },
          { // 线路状态
            label: '线路状态',
            value: 'state',
            type: 'select',
            placeholder: '请选择线路状态',
            default: '1',
          },

          { // 有效期:
            label: '有效期',
            value: 'validDays',
            type: 'select',
            placeholder: '请选择有效期',
            default: -1,
            options: [
              {
                label: '全部',
                value: -1,
              },
              {
                label: '即将到期',
                value: 1,
              },
            ],
          },
          { // 始发地
            label: '始发地',
            value: 'sourceAddress',
            type: 'cascader',
            default: [],
            clearable: true,
            options: getAddressOptions(),
          },
          { // 目的地
            label: '目的地',
            value: 'desAddress',
            type: 'cascader',
            default: [],
            clearable: true,
            options: getAddressOptions(),
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.companyName': function (newVal) {
      if (this.$route.path === '/manage/archives/customer/line' && newVal) {
        this.$refs.searchBox.setVal('companyName', newVal);
        this.$refs.searchBox.sub();
      }
    },
  },
  methods: {
    reset (val) {
      if (val === 'reset') {
        this.$refs.searchBox.setVal('companyName', '');
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 始发地
      if (Array.isArray(searchBoxData.sourceAddress) && searchBoxData.sourceAddress.length !== 0) {
        searchBoxData.sourceProvince = searchBoxData.sourceAddress[0];
        searchBoxData.sourceCity = searchBoxData.sourceAddress[1];
      }
      delete searchBoxData.sourceAddress;
      // 目的地
      if (Array.isArray(searchBoxData.desAddress) && searchBoxData.desAddress.length !== 0) {
        searchBoxData.desProvince = searchBoxData.desAddress[0];
        searchBoxData.desCity = searchBoxData.desAddress[1];
      }
      delete searchBoxData.desAddress;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    // const enumsList = await getEnumList({
    //   codeType: 'CUCUSTOMER_LINE_STATE,CUSTOMER_AUTH_STATE',
    // });
    const stateOptions = await selectSysStaticDataByCodeType({
      codeType: 'CUCUSTOMER_LINE_STATE',
      hasAll: true,
    });
    const resValidDays = await selectSysStaticDataByCodeType({
      codeType: 'CUCUSTOMER_LINE_VALIDDAYS',
    });
    const vehicleStatusOptions = await selectSysStaticDataByCodeType({
      codeType: 'CM_CUSTOMER_LINE.AUTHSTATE',
      hasAll: true,
    });
    this.searchBoxData.stateOptions = stateOptions;
    this.searchBoxData.vehicleStatusOptions = vehicleStatusOptions;
    this.$refs.tableBox.setJudgeConditions({
      validDays: Array.isArray(resValidDays) && resValidDays[0] ? (resValidDays[0].codeName || resValidDays[0].label || '') : '',
    });
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...((await getDepartmentAllList({
        isArchive: true,
      })) || []),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
